
      import Application from "#app/app";
      import environment from "#config";

      Application.create(environment.APP);
    